import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Zap } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
export function HeroVariant83() {
  const {
    t
  } = useLanguage();
  const {
    formattedPrice
  } = usePricing();
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[var(--bg-primary)]" data-id="element-1058">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-1059">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-1060">
          {/* Left Column: Editorial Typography */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl" data-id="element-1061">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[var(--text-primary)] leading-[1.2] mb-8" data-id="element-1062">
              Создаем уникальные сайты{' '}
              <motion.span animate={{
              rotate: [0, -5, 5, -5, 0]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} className="inline-flex items-center px-4 py-2 bg-[var(--accent)] text-white rounded-2xl text-2xl sm:text-3xl align-middle mx-2" data-id="element-1063">
                <Zap className="w-6 h-6 mr-2" data-id="element-1064" />
                для клиентов
              </motion.span>
              , нужно оплачивать{' '}
              <span className="inline-block w-16 h-10 sm:w-20 sm:h-12 mx-1 rounded-xl overflow-hidden align-middle" data-id="element-1065">
                <img src="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=100&q=80" alt="Work" className="w-full h-full object-cover" data-id="element-1066" />
              </span>{' '}
              только за обслуживание всего лишь{' '}
              <span className="inline-block text-[var(--accent)] border-b-4 border-[var(--accent)] pb-1 mt-2" data-id="element-1067">
                {formattedPrice} баксов в месяц
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-4 mt-10" data-id="element-1068">
              <button onClick={scrollToContact} className="group relative inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-xl text-white bg-[var(--accent)] overflow-hidden transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-1069">
                <div className="absolute inset-0 w-full h-full bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-1070"></div>
                <span className="relative flex items-center" data-id="element-1071">
                  {t('hero.cta')}
                  <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-1072" />
                </span>
              </button>
            </div>
          </motion.div>

          {/* Right Column: Clean Video */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:h-[800px] rounded-2xl overflow-hidden" data-id="element-1073">
            <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-1074">
              <source src="https://cdn.coverr.co/videos/coverr-coding-on-a-laptop-in-a-modern-office-2624/1080p.mp4" type="video/mp4" data-id="element-1075" />
            </video>
          </motion.div>
        </div>
      </div>
    </section>;
}